import React from 'react'

import FilterLink from '../filter/FilterLink'
import LabelIconListItem from '../../packages/kiti/components/list/LabelIconListItem'

const SelectableLink = ({ type, ...props }) => {
  if (type === 'listItem')
    return <LabelIconListItem {...props} bold={!!props.value} title={!!props.value && props.label} iconColor="dark3" />
  return <FilterLink {...props} />
}

export default SelectableLink
